import type { SubsystemStatus } from "../api";

/**
 * One subsystem's 🟢/🟡/🔴 status + evidence + recommended action (भाग E4).
 * Never aggregated into a single score — each tile stands on its own.
 */
export function StatusTile({ status }: { status: SubsystemStatus }): JSX.Element {
  return (
    <div className={`status-tile ${status.status}`}>
      <div className="name">
        <span className={`status-dot ${status.status}`} />
        {status.name.replace(/_/g, " ")}
      </div>
      <div className="evidence">{status.evidence}</div>
      <div className="action">→ {status.recommended_action}</div>
    </div>
  );
}
